// removed by extract-text-webpack-plugin
module.exports = {"component":"_2G2KvdnSpRAY6tOJJGd175"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAddressForm/Br/SearchCEP/TableCep/tableCep.css
// module id = 1040
// module chunks = 2